// extracted by mini-css-extract-plugin
export default {"signature":"style_signature__nDF0M","description":"style_description__XY47K","confirm":"style_confirm__VqAvW","buttonTray":"style_buttonTray__eEioP"};